import { RootState } from "@app/store/rootReducer";

const getUserLocationRequestState = (state: RootState) => state.component.userLocationRequest;

export const getVisibility = (state: RootState) => getUserLocationRequestState(state).visible;
